import { render, staticRenderFns } from "./TipoMedidaList.vue?vue&type=template&id=878f9f7e"
import script from "./TipoMedidaList.vue?vue&type=script&lang=js"
export * from "./TipoMedidaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports